export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      let animationActive = true;
      let prevPhrase = '';
      let typeInterval = null;
      let eraseInterval = null;

      const observer = new MutationObserver(() => {
        const container = document.getElementById('typing-text-placeholder');
        if (container) {
          animationActive = true;
          container.style.display = 'block';
          startAnimation(container);

          return;
        }

        const containerStop = document.getElementById('clean-placeholder');

        if (!containerStop) {
          return;
        }

        containerStop.style.display = 'none';
        stopAnimation(containerStop);
      });

      const stopAnimation = (container) => {
        clearInterval(eraseInterval);
        clearInterval(typeInterval);
        animationActive = false;
        container.innerHTML = '';
        container.setAttribute('data-phrase', '');
        prevPhrase = '';
      };
      const restartAnimation = (container) => {
        if (!animationActive) return;

        const textArray = container.innerHTML.split('');
        let index = textArray.length;

        setTimeout(() => {
          eraseInterval = setInterval(() => {
            if (index > 0) {
              container.innerHTML = container.innerHTML.slice(0, -1);
              index--;
            } else {
              clearInterval(eraseInterval);
              startAnimation(container);
            }
          }, 25);
        }, 2000);
      };
      const startAnimation = (container) => {
        if (!animationActive) return;
        const phrase = getRandomPhrase();
        container.setAttribute('data-phrase', phrase);
        container.innerHTML = '';

        const textArray = phrase.split('');
        let index = 0;

        typeInterval = setInterval(() => {
          if (index < textArray.length) {
            container.innerHTML += textArray[index];
            index++;
          } else {
            clearInterval(typeInterval);
            restartAnimation(container);
          }
        }, 50);
      };

      const getRandomPhrase = () => {
        const phrases = [
          'A masterpiece is happening. Right now. Hold tight.',
          'All we need is just a little patience – Guns N Roses',
          'Anticipation, anticipation is making me late, is keeping me waiting – Carly Simon',
          'Good names come to those who wait... almost there!',
          'The waiting is the hardest part – Tom Petty',
        ];

        const randomPhrase =
          phrases[Math.floor(Math.random() * phrases.length)];

        if (randomPhrase === prevPhrase) return getRandomPhrase();

        prevPhrase = randomPhrase;
        return randomPhrase;
      };

      instance.data('TypingTextAnimation', () => {});
      observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['id'],
      });
    });
  },
};
